import React from 'react';
import II18 from '../translate/II18';
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Icon,
  Link
} from 'framework7-react';
import QrReader from 'react-qr-reader';
import PropTypes from 'prop-types';

/**
 * Scanner
 * 
 * @param {{
    showCloseButton,
    stopScanner,
    handleScan,
    scannerOn,
    startScanner,
  }} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function Scanner(props) {
  const {
    showCloseButton,
    stopScanner,
    handleScan,
    scannerOn,
    startScanner
  } = props;

  const handleError = err => {
    console.error(err);
  };

  return (
    <Card className="start-qr-scanner">
      <CardHeader style={{ alignItems: 'flex-start' }}>
        <p style={{ textAlign: 'center' }}>
          <II18>qr_start_scan</II18>
        </p>
        {showCloseButton && (
          <Link onClick={stopScanner}>
            <Icon material={'close'} />
          </Link>
        )}
      </CardHeader>
      <CardContent style={{ height: '80vw' }}>
        <div style={{ position: 'relative', height: '100%' }}>
          {scannerOn && (
            <QrReader
              className="scale-in-center"
              delay={200}
              onError={handleError}
              onScan={handleScan}
              style={{ width: '80%', margin: '0 auto', paddingTop: 15 }}
            />
          )}

          <div
            className={scannerOn ? 'slide-out-bck-center' : ''}
            style={{
              display: 'flex',
              justifyContent: 'center',
              height: '100%',
              width: '100%',
              alignItems: 'center',
              position: 'absolute',
              top: 0
            }}
          >
            <Link
              className="button bg-color-blue color-white"
              style={{
                height: 39,
                display: 'flex'
              }}
              onClick={startScanner}
            >
              <Icon f7="qrcode" />
              <span>
                <II18>qr_start_scan_btn</II18>
              </span>
            </Link>
          </div>
        </div>
      </CardContent>

      <CardFooter className="swing-in-top-fwd">
        <II18>qr_start_message</II18>
      </CardFooter>
    </Card>
  );
}

Scanner.propTypes = {
  showCloseButton: PropTypes.bool,
  stopScanner: PropTypes.func,
  handleScan: PropTypes.func,
  scannerOn: PropTypes.bool,
  startScanner: PropTypes.func
};
